import { isLocalHost } from './utils/env/localhost';
import { isTrustedHost } from './utils/env/trusted';

export function verifyHost() {
  if (isLocalHost() || isTrustedHost()) return;
  throw new Error('');
}
